<template>
  <div class="mt-2 employment-period-editor">
    <table class="table table-bordered table-hover mb-2">
      <thead>
        <tr>
          <th width="8%">Lp.</th>
          <th>od</th>
          <th>do</th>
          <th width="20%">liczba dni</th>
          <th width="8%"><span class="sr-only">Akcje</span></th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, index) in schema.value.ranges.$items" :key="'value_range_' + index">
          <td class="text-center align-middle">{{ index + 1 }}.</td>

          <td>
            <w-datepicker title :model="item.$item.dateFrom" />
          </td>

          <td>
            <w-datepicker title :model="item.$item.dateTo" />
          </td>

          <td>
            <input
              :value="item.$item.days.$model"
              type="number"
              class="form-control"
              aria-label="liczba dni"
              disabled
            />
          </td>

          <w-row-buttons
            class="middle"
            :model="item.$item"
            :move-up="index != 0"
            :move-down="item.$item.$parent.$value.length - 1 !== index"
          />
        </tr>
      </tbody>
    </table>

    <w-add-row class="btn-light" :model="schema.value.ranges">Dodaj wiersz</w-add-row>

    <div class="row form-group mt-3 mb-0">
      <div class="col-md-6 col-lg-5">
        <label>Łączna liczba dni podlegająca odliczeniu</label>
        <input :value="schema.value.totalDays.$model || 0" type="number" class="form-control" disabled />
      </div>
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

export default {
  components,
  props: {
    schema: {
      type: Object,
      required: true
    }
  }
};
</script>

<style>
.employment-period-editor .vdp-datepicker__calendar {
  z-index: 1200;
}
</style>
